export default (toConvert => toConvert.toLowerCase());
